import * as L from 'leaflet';

export class AriaLabelDivIcon extends L.DivIcon {
  private ariaLabel: string | undefined;

  constructor(options: L.DivIconOptions, ariaLabel: string | undefined = undefined) {
    super(options);
    this.ariaLabel = ariaLabel;
  }

  // See https://leafletjs.com/reference-1.7.1.html#divicon-option
  createIcon(oldIcon?: HTMLElement): HTMLElement {
    const icon = L.DivIcon.prototype.createIcon.call(this, oldIcon);
    if (this.ariaLabel) {
      icon.setAttribute('aria-label', this.ariaLabel);
    }
    return icon;
  }
}
